import { TabStyles } from '@tableau/widgets';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

import { cssClass, fillStyle, flexColumnStyle } from '../../style';

const cssPrefix = 'SpaceContainer';

export const TabpanelScrollContainerTestIdSuffix = 'tabpanel-scroll-container';

export namespace SpaceContainerStyles {

  export const SpaceContainer = cssClass(cssPrefix, 'space-container', fillStyle, flexColumnStyle, {
    // For spaces with tabs and subplaces, the tabs widget renders a scroll container with some padding,
    // which we don't use because we display the subplace contents separately. So, find that div
    // using the only identifier we have, and hide it completely.
    '$nest': {
      [`div[data-tb-test-id$="${TabpanelScrollContainerTestIdSuffix}"]`]: {
        display: 'none',
      }
    }
  });

  export const GlobalSpaceHorizontalPadding = TabStyles.Spacing.ExtraLargeSpace;

  export const MastheadArea = cssClass(cssPrefix, 'space-masthead-area', {
    paddingTop: TabStyles.Spacing.LargeSpace,
    paddingRight: GlobalSpaceHorizontalPadding,
    paddingBottom: TabStyles.Spacing.MediumSpace,
    paddingLeft: GlobalSpaceHorizontalPadding,
  });

  export const MastheadSubheadingArea: React.CSSProperties = {
    minWidth: 0, // 0 is the default
    color: CommonStyles.Colors.Grey102,
    fontSize: '14px',
  };

  export const SubplaceArea = cssClass(cssPrefix, 'space-subplace-area', {
    flex: 1,
    position: 'relative'
  });

  export const SubplaceAreaCenterMargins = cssClass(cssPrefix, 'space-subplace-area-center-margins', {
    margin: '0 24px 0'
  });

  export const SubplaceContainer = cssClass(cssPrefix, 'space-subplace-container', fillStyle, {
    // For subspace components that use flexbox layout at their root to fill the entire area,
    // the container needs to be a flex element. One might think it needs to have flex-direction: column,
    // but this appears not to be the case.
    display: 'flex',
  });

  export const SpaceTabsContainer = cssClass(cssPrefix, 'space-tabs-container', {
    marginTop: CommonStyles.Sizes.DefaultSpace,
    $nest: {
      ['div[role="tablist"]']: {
        backgroundColor: 'transparent !important' as any
      }
    }
  });

  export const SpaceTabHeight = 26;

  export const SpaceTabsBottom = cssClass(cssPrefix, 'space-tabs-bottom', {
    height: 3, // Matches the height of the bottom bar of the TabsWidget
    backgroundColor: TabStyles.Colors.L3,
    width: '100%',
    position: 'relative',
    top: SpaceTabHeight,
    marginBottom: '1px' // To allow for the focus indicator
  });

  export const SpaceTabContainer = cssClass(cssPrefix, 'space-tab-container', {
    fontSize: '15px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    flexDirection: 'row',
    paddingBottom: CommonStyles.Sizes.DefaultSpace,
    height: SpaceTabHeight,
    boxSizing: 'border-box'
  });

  export const SpaceTabCountContainer = cssClass(cssPrefix, 'space-tab-count-container', {
    marginLeft: TabStyles.Spacing.MediumSpace,
    fontSize: '12px',
    marginBottom: '-1px' // count vertically align with the tab label
  });

  export const SpaceCenteredContent = cssClass(cssPrefix, 'space-centered-content', {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  });
}
